import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Package, X } from 'lucide-react';
import { getClassName } from '../../../utils/ui/classes';

const AccessorialCard = ({
  selected,
  canSelect,
  canDelete,
  iconSlug,
  name,
  className,
  onSelect,
  onDelete,
  size,
}) => {
  function handleSelect(e) {
    if (!canSelect) {
      return;
    }
    e.preventDefault();
    onSelect();
  }

  function handleDelete(e) {
    e.stopPropagation();
    e.preventDefault();
    onDelete();
  }

  return (
    <div className={getClassName(className)}>
      <div
        className={getAccessorialClass({ selected, canSelect, size })}
        onClick={canSelect ? handleSelect : undefined}
      >
        <div className="flex flex-col items-center justify-center w-full px-2">
          {iconSlug ? (
            <i className={getIconClass(iconSlug)} />
          ) : (
            <Package className="w-8 h-8 text-grey" />
          )}
          <span
            className="mt-2 text-center text-sm leading-tight break-words w-full"
            title={name}
          >
            {name}
          </span>
        </div>

        {canDelete && (
          <button
            type="button"
            className="absolute top-1 right-1 flex items-center justify-center w-6 h-6 rounded text-grey hover:text-grey-darker hover:bg-grey-lightest"
            onClick={handleDelete}
            aria-label="Delete"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

AccessorialCard.propTypes = {
  selected: PropTypes.bool,
  canSelect: PropTypes.bool,
  canDelete: PropTypes.bool,
  onDelete: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  iconSlug: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  size: PropTypes.string,
};

AccessorialCard.defaultProps = {
  selected: false,
  canSelect: false,
  canDelete: false,
  size: 'normal',
};

export default AccessorialCard;

const baseClasses = [
  'relative',
  'flex',
  'items-center',
  'justify-center',
  'bg-white',
  'shadow',
  'rounded',
  'border-2',
  'overflow-hidden',
];

function getAccessorialClass({
  selected = false,
  canSelect = false,
  size = 'normal',
}) {
  return getClassName(baseClasses, {
    'border-transparent': !selected,
    'border-green': selected,
    'border-solid': selected,
    'cursor-pointer': canSelect,
    'w-40 h-40': size === 'normal',
    'w-32 h-32': size === 'small',
    'w-full h-40': size === 'auto',
  });
}

function getIconClass(iconSlug) {
  const className = {
    'mx-0': true,
  };

  if (iconSlug) {
    className['icon-normal'] = true;
    className[iconSlug] = true;
  }

  return classnames(className);
}
